import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Show banner with a small delay for smoother UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 p-4 md:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden md:flex p-3 bg-amber-100 dark:bg-amber-900/30 rounded-xl">
            <Cookie className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-base md:text-lg mb-2 text-slate-800 dark:text-white">
              Мы используем cookies
            </h3>
            <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
              Мы используем файлы cookie для обеспечения работы сайта, сохранения ваших настроек и улучшения пользовательского опыта. 
              Продолжая использовать сайт, вы соглашаетесь с нашей{' '}
              <Link 
                to="/cookie-policy" 
                className="text-blue-600 hover:underline dark:text-blue-400"
              >
                Политикой использования cookies
              </Link>.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button 
                onClick={acceptCookies}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6"
              >
                Принять все
              </Button>
              <Button 
                onClick={declineCookies}
                variant="outline"
                className="border-slate-300 dark:border-slate-600"
              >
                Только необходимые
              </Button>
            </div>
          </div>
          <button 
            onClick={declineCookies}
            className="p-1 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
